import { Icon } from "@iconify/react/dist/iconify.js";
import { Link, useParams } from "react-router-dom";
import ConversacionesPlantelLayer from "../../components/plantels/conversaciones/ConversacionesPlantelLayer";

const PlantelConversacionesPage = () => {
  const { plantelId } = useParams();

  return (
    <div className="container-fluid">
      {/* HEADER */}
      <div className="mb-3">
        <div className="d-flex flex-column flex-md-row align-items-md-center justify-content-between gap-2">
          <div className="d-flex align-items-center gap-2 flex-wrap">
            <h6 className="mb-0 fw-semibold">
              Conversaciones del plantel
            </h6>
          </div>

          <Link
            className="btn btn-outline-primary d-flex align-items-center gap-2 btn-sm"
            to="/planteles"
          >
            <Icon icon="mdi:arrow-left" width="18" />
            <span>Atras</span>
          </Link>
        </div>
      </div>

      {/* CARD */}
      <div className="card radius-8">
        <div className="card-body">
          <ConversacionesPlantelLayer plantelId={plantelId} />
        </div>
      </div>
    </div>
  );
};

export default PlantelConversacionesPage;
